/** General utility functions */

/**
 * Safely accesses an object using a flattened key
 *
 * @param {Object} obj base object
 * @param {String} key dot delimited access key for the object
 * @param {Object} defaultReturn default return when a match isn't found
 */
const get = (obj, key, defaultReturn = null) => {
  const res = key
    .split('.')
    .reduce((returnVal, currentKey) => (returnVal ? returnVal[currentKey] : defaultReturn), obj);
  return res !== null && res !== undefined ? res : defaultReturn;
}

/**
 * Converts a string from camel to title case
 *
 * @param {String} camelCase string to be converted from camelcase to Title Cased
 */
const titleize = (camelCase) => camelCase
  .replace(/([A-Z])/g, (match) => ` ${match}`)
  .replace(/^./, (match) => match.toUpperCase());


/**
 * Slugify function equivalent to the one we use in the
 * API. It takes a `str` string and turns it into a
 * URL-friendly value.
 *
 * @param {String} str string to slugify
 * @param {Integer} len max response length
 */
const slugify = (str, len = 64) => {
  if (str === undefined || str === null) str = '';
  return str.toString().trim().toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^\w-]+/g, '')
    .replace(/--+/g, '-')
    .replace(/^-+/, '')
    .replace(/-+$/, '')
    .substr(0, len);
};  

/**
 * Provide cookie options based on environment
 */
const getCookieOptions = () => {

  /*
  path (string): cookie path, use / as the path if you want your cookie to be accessible on all pages
  expires (Date): absolute expiration date for the cookie
  maxAge (number): relative max age of the cookie from when the client receives it in seconds
  domain (string): domain for the cookie (sub.domain.com or .allsubdomains.com)
  secure (boolean): Is only accessible through HTTPS?
  httpOnly (boolean): Is only the server can access the cookie?
  sameSite (boolean|none|lax|strict): Strict or Lax enforcement
  */

  let opts = {
    path: '/',
    domain: 'localhost',
    secure: false
  };

  let date = new Date();
  date.setDate(date.getDate() + 30);
  opts.expires = date;

  if (process.env.NODE_ENV !== 'development') {
    opts.domain = ".idplans.com";
    opts.secure = true;
  }

  return opts;
};

/**
 * Parses a nested object using a dot delimited key
 * @param {Object} object The object
 * @param {String} key Dot delimited key
 * @returns Value of the nested key
 */
const getNestedElement = (object, key) => {
  if (key.indexOf('.') > -1) {
    let parts = key.split('.')
    let part = parts.shift()
    if (!object[part]) return null
    return getNestedElement(object[part], parts.join('.'))
  }
  return object[key]
}

export { get, titleize, getCookieOptions, slugify, getNestedElement };